import { CreditBureau } from '../credit/credit-report-request';
import { CreditType } from '../credit/credit-report-transaction';
import { EffectivePrice } from './effective-price';

export class CreditSettings {
  clientId?: string;
  isActive: boolean = false;
  priceHistory?: EffectivePrice[] = [];
  accounts?: CreditAccount[] = [];
  costSheet?: CreditCostItem[] = [];

  constructor(clientId: string) {
    this.clientId = clientId;
  }
}

export interface CreditAccount {
  creditReportingAgencyId?: string;
  creditType?: CreditType;
  credentials?: KeyValuePair<string>[];
}

export interface CreditCostItem {
  creditReportingAgencyId?: string;
  creditType?: CreditType;
  borrowerType?: BorrowerType;
  creditBureaus?: CreditBureau[]; // default can be set when initializing
  cost?: number;
}

export interface KeyValuePair<T> {
  key?: string;
  value?: T;
}

export enum BorrowerType {
  Individual = 'Individual',
  Joint = 'Joint',
}
